var stickyCta = document.querySelector('.sticky-cta');

if (stickyCta) {
    stickyCta.classList.add('show-for-xlarge');
}

var stickyForm = document.querySelector('.block_quotation .right');
var stickFormInner = document.querySelector('.block_quotation .inner');
var header = document.querySelector('.header');
var lastScrollTop = 0;

function stickyFormScroll() {
    var headerHeight = header.offsetHeight;
    var form = stickyForm.getBoundingClientRect();
    var inner = stickFormInner.getBoundingClientRect();
    var st = window.pageYOffset || document.documentElement.scrollTop;

    if (st > lastScrollTop) {
        if (form.top <= headerHeight && !stickyForm.classList.contains('fixed-desktop-bottom-absolute')) {
            stickyForm.classList.add('fixed-desktop');
        }
        if (form.bottom <= inner.bottom) {
            stickyForm.classList.remove('fixed-desktop');
            stickyForm.classList.add('fixed-desktop-bottom-absolute');
        }
    } else {
        if (inner.top <= form.top) {
            stickyForm.classList.remove('fixed-desktop');
            stickyForm.classList.remove('fixed-desktop-bottom-sticky');
            stickyForm.classList.remove('fixed-desktop-bottom-absolute');
        }

        if (form.bottom > (window.innerHeight || document.documentElement.clientHeight) && stickyForm.classList.contains('fixed-desktop-bottom-absolute')) {
            stickyForm.classList.add('fixed-desktop-bottom-sticky');
            stickyForm.classList.remove('fixed-desktop');
            stickyForm.classList.remove('fixed-desktop-bottom-absolute');
        }
    }

    lastScrollTop = st <= 0 ? 0 : st;
}

window.addEventListener('scroll', stickyFormScroll);
